import { submissions as actionTypes } from "$constants/action-types";

export const fetchAll = (projectId, taskFormId) => ({
  type: actionTypes.FETCH_ALL,
  projectId,
  taskFormId,
});

export const fetchAllSuccess = (result) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  result,
});

export const createReport = (projectId, fileType, filters, insightFilters) => ({
  type: actionTypes.CREATE_REPORT,
  projectId,
  fileType,
  filters,
  insightFilters,
});

export const createReportForReporters = (
  projectId,
  reportData,
  filters,
  insightFilters
) => ({
  type: actionTypes.CREATE_REPORT_EMAILS,
  projectId,
  report: reportData,
  filters,
  insightFilters,
});



// WEBPACK FOOTER //
// ./src/actions/submissions.js